import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://a18b304b971613334bca28d5c3f336fe@o4510760006647808.ingest.us.sentry.io/4510760010055680",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // Capture breadcrumbs for better error tracking
  maxBreadcrumbs: 50,
  tracesSampleRate: 1.0,
  integrations : [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    })
  ]
});



export default function initSentry() {}

/**
 * Função para setar informações do usuário no Sentry
 * Utilizado quando o usuario faz login
 * 
 * Exemplo de uso em seu auth/provider:
 * import { setSentryUser } from 'src/init-sentry';
 * setSentryUser({
 *   id: user.id,
 *   email: user.email,
 *   name: user.fullName,
 *   role: user.role,
 * });
 */
export function setSentryUser(user: {
  id: string;
  email: string;
  name?: string;
  role?: string;
  [key: string]: any;
}) {
  const { id, email, name} = user;

  Sentry.setUser({
    id,
    email,
    username: name,
  });
  
}

/**
 * Função para limpar dados do usuário 
 * utilizado quando o usuario faz logout
 */
export function clearSentryUser() {
  Sentry.setUser(null);
}

/**
 * Função para capturar erros de requisição HTTP
 * 
 * Exemplo de uso:
 * catch((error) => {
 *   captureRequestError({
 *     url: error.config.url,
 *     method: error.config.method,
 *     status: error.response.status,
 *     message: error.message,
 *     response: error.response.data,
 *   });
 * })
 */
export function captureRequestError(request: {
  url: string;
  method: string;
  status?: number;
  message: string;
  response?: any;
}) {
  // Adiciona breadcrumb da requisição que falhou
  Sentry.addBreadcrumb({
    category: 'http-request',
    message: `${request.method.toUpperCase()} ${request.url}`,
    level: 'error',
    data: {
      status: request.status,
      method: request.method,
      url: request.url,
    },
  });

  // Adiciona contexto com detalhes da requisição
  Sentry.setContext('failed_request', {
    url: request.url,
    method: request.method,
    status: request.status,
    message: request.message,
    responsePreview: request.response ? JSON.stringify(request.response).substring(0, 500) : null,
  });

  // Adiciona tags para filtrar erros no dashboard
  Sentry.setTag('request_method', request.method);
  Sentry.setTag('request_status', request.status?.toString() || 'unknown');
  Sentry.setTag('error_type', 'http_error');
}